import { Avatar } from '@mui/material';
import Badge from '@mui/material/Badge';

import { getFirstAndLastName } from '@/utils/getFirstAndLastName';

interface Props {
	name?: string;
	poleColor: string;
	regime: string;
	size?: number;
	fontSize?: number;
	bgColor: string;
	active: boolean;
	textColor: string;
	height?: number;
	scaleCode?: string;
}

export default function BadgeAvatar({
	name = '',
	poleColor,
	regime,
	size = 48,
	fontSize = 16,
	bgColor,
	active,
	textColor,
	scaleCode = '',
}: Props) {
	const stringAvatar = (name: string) => {
		return {
			children: `${getFirstAndLastName(name)
				?.split(' ')
				.map((el) => el[0]?.toUpperCase())
				.filter((el, idx) => idx < 2)
				.join('')}`,
		};
	};
	const scale7x7 = ['1', '28', '29', '34', '35', '36', '37'];
	const scale14x14 = ['2', '31', '32', '33'];
	const avatarProps = active ? stringAvatar(name) : {};
	const badgeContent =
		regime === 'TURNO'
			? scale7x7.includes(scaleCode)
				? '7x7'
				: scale14x14.includes(scaleCode)
					? '14x14'
					: 'TURNO'
			: 'ADM';
	return (
		<Badge
			className={textColor}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
			badgeContent={badgeContent}
			sx={{
				'& .MuiBadge-badge': {
					fontSize: 8,
					height: 14,
					minWidth: '24px',
					fontWeight: 'semibold',
					fontFamily: 'Graphie',
					marginRight: '50%',
					backgroundColor: bgColor,
					color: textColor,
				},
			}}
			style={{
				border: '1px solid #dbdada',
				borderRadius: '100%',
				padding: '3px',
			}}
		>
			<Avatar
				{...avatarProps}
				sx={{
					width: size,
					height: size,
					backgroundColor: poleColor,
					fontSize,
				}}
			/>
		</Badge>
	);
}
